(function ($) {
  "use strict";

  var doc = $( document );
  var win = $( window );

  var BACOLA_APP = {
    init: function() {
      this.dom();
      this.dropdownParent();
      this.allCategories();
      this.siteLoading();
      this.siteScroll();
      this.mainMenu();
      this.mobileMenu();
      this.mobileSearch();
      this.filterLocation();
      this.productSorting();
      this.productHover();
      this.productQty();
      this.checkboxList();
      this.sidebarFilter();
      this.myAccountMenu();
      this.loginForm();
      this.quickView();
      $('[data-toggle="tooltip"]').tooltip();
    },
    dom: function() {
      var body = $( 'body' );
      var html = $( 'html' );
    },
    dropdownParent: function() {
      var content = $( '.dropdown-parent' );
      var categories = $( '.dropdown-categories' );

      var h = categories.outerHeight();
      if ( content.length ) {
        content.css( 'height', h );
      }
    },
    allCategories: function() {
      var content = $( '.header-nav .all-categories' );
      var button = content.find( '> a' );
      var subMenu = content.find( '.dropdown-categories' );

      button.on( 'click', function(e) {
        e.preventDefault();
        if ( $(this).parent().hasClass( 'click' ) ) {
          subMenu.toggleClass( 'active' );
        }
      });
    },
    siteLoading: function() {
      var loading = $( '.site-loading' );

      win.load( function() {
        if (loading.length) {
	    		loading.delay(800).fadeOut("slow");
	    	}
      });
    },
    siteScroll: function() {
      var siteScroll = $( '.site-scroll' );
      siteScroll.each( function() {
        const ps = new PerfectScrollbar( $( this )[0], {
          suppressScrollX: true,
        });
      });
    },
    mainMenu: function() {
      var subMenuItem = $( '.primary-menu .sub-menu .menu-item' ).find( '> a' );
      var textWrapper = $( '<span class="text"></span>' );
      subMenuItem.wrapInner( textWrapper );

      const spacing = () => {
        var containerWidth = $( '.header-wrapper > .container' ).width();
        var windowWidth = $(window).width();

        var spacing = windowWidth - containerWidth;
        var megaSubmenu = $( '.primary-menu .mega-menu > .sub-menu' );
        megaSubmenu.css( 'padding-left', spacing / 2 );
        megaSubmenu.css( 'padding-right', spacing / 2 );
      }

      $( window ).on( 'load', () => {
        spacing();
      });

      $( window ).on( 'resize', () => {
        spacing();
      });

      var megaMenu = $( '.primary-menu .mega-menu' );
      var siteMask = $( '.site-overlay' );

      megaMenu.on( 'hover', () => {
        siteMask.toggleClass( 'active-for-mega' );
      });
    },
    mobileMenu: function() {
      var canvasMenu = $( '.site-canvas' );
      var siteOverlay = $( '.site-overlay' );
      var canvasButton = $( '.header-canvas > a' );
      var canvasClose = $( '.site-canvas .close-canvas' );

      var tl = gsap.timeline( { paused: true, reversed: true } );
      tl.set( canvasMenu, {
        autoAlpha: 1
      }).to( canvasMenu, .5, {
        x:0,
				ease: 'power4.inOut'
      }).to( siteOverlay, .5, {
        autoAlpha: 1,
        ease: 'power4.inOut'
      }, "-=.5");

      canvasButton.on( 'click', function(e) {
				e.preventDefault();
        siteOverlay.addClass( 'active' );
				tl.play();
			});

      canvasClose.on( 'click', function(e) {
				e.preventDefault();
				tl.reverse();
        setTimeout( function() { 
          siteOverlay.removeClass( 'active' );
        }, 1000);
			});

      siteOverlay.on( 'click', function(e) {
        e.preventDefault();
        tl.reverse();
        setTimeout( function() { 
          siteOverlay.removeClass( 'active' );
        }, 1000);
      });

      var menuChildren = $( '.canvas-menu .menu-item-has-children' );
      menuChildren.append( '<span class="menu-dropdown"><i class="klbth-icon-down-open-big"></i></span>' );

      $( '.canvas-menu .menu-item-has-children .menu-dropdown' ).on( 'click', function(e) {
        e.preventDefault();

        var link = $(this);
        var closestUL = link.closest( 'ul' );
        var activeItem = closestUL.find( '.active' );
        var closestLI = link.closest( 'li' );
        var linkClass = closestLI.hasClass( 'active' );
        var count = 0;

        const resetAnimation = () => {
          activeItem.removeClass( 'active' );
        }

        gsap.to( closestUL.find( 'ul' ), .5, { height: 0, ease: 'power4.inOut', onComplete: resetAnimation() });

        if ( !linkClass ) {
          gsap.to( closestLI.children( 'ul' ), .5, { height: 'auto', ease: 'power4.inOut' } );
          closestLI.addClass( 'active' );
        }
      });

    },
    mobileSearch: function() {
      var searchButton = $( '.header-mobile-nav .menu-item .search' );
      var searchHolder = $( '.header-search' );

      if ( searchButton.length ) {
        searchButton.on( 'click', function(e) {
          e.preventDefault();
          $(this).toggleClass( 'active' );
          searchHolder.toggleClass( 'active' );
        });
      }
    },
    filterLocation: function() {
      var locationButton = $( '.site-location > a' );
      var locationSelected = $('.site-location a .current-location');
      var locationClose = $( '.close-popup' );
      var locationHolder = $( '.select-location' );

      locationButton.each(function() {
        $(this).on( 'click', function(e) {
          e.preventDefault();
          locationHolder.addClass( 'active' );
        });
      });

      locationClose.on( 'click', function(e) {
        e.preventDefault();
        locationHolder.removeClass( 'active' );
      });

      function minPrice(min) {
        if (!min.id) {
          return min.text;
        }

        var $min;

        if ( min.element.dataset.min ) {
          $min = $( '<span>' + min.text + '</span><span class="min-price">' + min.element.dataset.min + '</span>' );
        } else {
          $min = min.text;
        }

        return $min;
      }
      var locations = $('.site-area').select2({
        allowClear: true,
        placeholder: 'Select an option',
        templateResult: minPrice,
        dropdownCssClass: 'site-location-select',
        dropdownParent: $('.select-location .search-location'),
        sorter: function(data) {
          return data.sort(function (a, b) {
            if (a.text > b.text) {
              return 1;
            }
            if (a.text < b.text) {
              return -1;
            }
            return 0;
          });
        },
        closeOnSelect: false,
      }).on("select2:closing", function(e) {
        e.preventDefault();
      }).on("select2:closed", function(e) {
        list.select2("open");
      });
      var placeholder = locations.data( 'placeholder' );
      locations.on( 'select2:open', function(e) {
        $('.select2-search__field').attr('placeholder', placeholder);
        $('.select2-search').append('<svg data-testid="MagnifyGlass" viewBox="0 0 16 16" class="css-ekjjru"><path d="M14.23437,15.10449l-3.2539-3.25488a6.13908,6.13908,0,1,1,1.63574-1.85352c-.05859.10156-.11816.19922-.17969.29492l-.63086-.40625c.05567-.08593.10938-.17383.16016-.26269a5.406,5.406,0,1,0-1.19922,1.43945.37776.37776,0,0,1,.50781.02051l3.49121,3.49121Z" fill="currentColor"></path></svg>');
      });

      locations.select2("open");
      
      locations.on( 'select2:select', function(e) {
        locationHolder.removeClass( 'active' );
        locationSelected.html(e.params.data.text)
        /* console.log("select", e.params.data.text); */
      });
      /* locations.on( 'change', function(e) {
        console.log("change", e);
      }); */
    },
    productSorting: function() {
      var container = $( '.filterSelect' );
      container.each(function() {
        var filterClass = $(this).data('class');
        var filterSelect = $(this).select2({
          minimumResultsForSearch: Infinity,
          dropdownAutoWidth: true,
          dropdownCssClass: filterClass,
        });
      });
    },
    productHover: function() {
      var product = $( '.products .product' );

      product.each( function(e) {
        var fadeBlock = $(this).find( '.product-fade-block' );
        var contentBlock = $(this).find( '.product-content-fade' );
        var outerHeight = 0;

        if ( fadeBlock.length ) {
          fadeBlock.each( function(e) {
            var self = $(this);
            outerHeight += self.outerHeight();
    
            contentBlock.css( 'marginBottom', -outerHeight );
          });
        }
      });
    },
    productQty: function() {
      function qty() {
        var container = $( '.quantity:not(.ajax-quantity)' );
        container.each( function() {
          var self = $( this );
          var buttons = $( this ).find( '.quantity-button' );
          buttons.each( function() {
            $(this).on( 'click', function(event) {
              var qty_input = self.find( '.input-text.qty' );
              if ( $(qty_input).prop('disabled') ) return;
              var qty_step = parseFloat($(qty_input).attr('step'));
              var qty_min = parseFloat($(qty_input).attr('min'));
              var qty_max = parseFloat($(qty_input).attr('max'));


              if ( $(this).hasClass('minus') ){
                var vl = parseFloat($(qty_input).val());
                vl = ( (vl - qty_step) < qty_min ) ? qty_min : (vl - qty_step);
                $(qty_input).val(vl);
              } else if ( $(this).hasClass('plus') ) {
                var vl = parseFloat($(qty_input).val());
                vl = ( (vl + qty_step) > qty_max ) ? qty_max : (vl + qty_step);
                $(qty_input).val(vl);
              }

              qty_input.trigger( 'change' );
            });
          });
        });
      }

      qty();
      $('body').on( 'updated_cart_totals', qty );
    },

    checkboxList: function() {
      var container = $( '.site-checkbox-lists.hidden-sub' );
      var menu = $( '.site-checkbox-lists > .site-scroll > ul' );
      var menuChildren = container.find( '.cat-parent' );
      menuChildren.append( '<span class="menu-dropdown"><i class="klbth-icon-plus"></i></span>' );

      var menuHeight = menu.height();

      if ( menuHeight > 300 ) {
        menu.addClass( 'scroll-active' )
      }

      container.each( function() {
        $(this).find( '.menu-dropdown' ).on( 'click', function(e) {
          e.preventDefault();
  
          var link = $(this);
          var closestUL = link.closest( 'ul' );
          var activeItem = closestUL.find( '.active' );
          var closestLI = link.closest( 'li' );
          var linkClass = closestLI.hasClass( 'active' );
          var count = 0;
  
          const resetAnimation = () => {
            activeItem.removeClass( 'active' );
          }
  
          gsap.to( closestUL.find( 'ul' ), .5, { height: 0, ease: 'power4.inOut', onComplete: resetAnimation() });
  
          if ( !linkClass ) {
            gsap.to( closestLI.children( 'ul' ), .5, { height: 'auto', ease: 'power4.inOut' } );
            closestLI.addClass( 'active' );
          }
        });
      });
    },
    sidebarFilter: function() {
      var sidebar = $( '#sidebar' );
      var button = $( '.filter-toggle' );
      var siteOverlay = $( '.site-overlay' );
      var close = $( '.close-sidebar' );

      var tl = gsap.timeline( { paused: true, reversed: true } );
      tl.set( sidebar, {
        autoAlpha: 1
      }).to( sidebar, .5, {
        x:0,
				ease: 'power4.inOut'
      }).to( siteOverlay, .5, {
        autoAlpha: 1,
        ease: 'power4.inOut'
      }, "-=.5");

      button.on( 'click', function(e) {
				e.preventDefault();
        siteOverlay.addClass( 'active' );
				tl.reversed() ? tl.play() : tl.reverse();
			});

      close.on( 'click', function(e) {
				e.preventDefault();
				tl.reverse();
        setTimeout( function() { 
          siteOverlay.removeClass( 'active' );
        }, 1000);
			});
    },
    myAccountMenu: function() {
      var container = $( '.my-account-navigation' );

      if ( container.length ) {
        var button = $( '.account-toggle-menu' );

        button.on( 'click', function() {
          container.toggleClass(  'dropdown');
        });
      }
    },
    loginForm: function() {
      var tab = $( '.login-page-tab li' );
      var forms = $( '.login-form-container' );

      const recoverbutton = document.querySelectorAll( '.recover-button' );
      if ( recoverbutton !== null ) {
        for ( var i = 0; i < recoverbutton.length; i++ ) {
          const self = recoverbutton[i];

          self.addEventListener( 'click', ( e ) => {
            e.preventDefault();
            forms.toggleClass( 'show-recovery-form' );
          });

        }
      }

      const cancelrecover = document.querySelectorAll( '.cancel-recovery' );
      if ( cancelrecover !== null ) {
        for ( var i = 0; i < cancelrecover.length; i++ ) {
          const self = cancelrecover[i];

          self.addEventListener( 'click', ( e ) => {
            e.preventDefault();
            forms.removeClass('show-recovery-form');
          });

        }
      }

      var removeClass = () => {
        for ( var i = 0; i < tab.length; i++ ) {
          if ( tab[i].children[0].classList.contains( 'active' ) ) {
            tab[i].children[0].classList.remove('active');
          }
        }
      }

      for ( var i = 0; i < tab.length; i++ ) {
        const button = tab[i].children[0];
        button.addEventListener( 'click', (event) => {
          event.preventDefault();

          forms.removeClass('show-recovery-form');
   
          if ( !event.target.classList.contains( 'active' ) ) {
            removeClass();
            event.target.classList.add( 'active' );
            forms.toggleClass( 'show-register-form' );
          }
        });
      }
    },
    quickView: function() {
      var button = $( '.quick-view-button' );

      button.each( function() {
        $( this ).magnificPopup({
          type:'inline',
          callbacks: {
            /* open: function() {
              $('.woocommerce-product-gallery #images').get(0).slick.setPosition();
              $('.woocommerce-product-gallery #thumbnails').get(0).slick.setPosition();
            } */
          }
        });
      });
    }
  }

  doc.ready( () => {
    BACOLA_APP.init();
  });

	$(document).ready(function() {
		$('.all-categories > a').on('click', function (e) {
			e.preventDefault();
			$(".dropdown-categories").collapse('toggle');
		});

	});

}(jQuery));